import { Box, Typography } from "@mui/material";

import { DashboardStates, DashboardList } from "../components";

export const CommercialsDashboard = () => {
    return (
        <Box py={2} >
            <Box display={'flex'} flexDirection={'column'} alignItems={'start'} px={2} mb={2} >
                <Typography variant="subtitle1" color="text.primary" > Commercial Programme Overview </Typography>
                <Typography variant="caption" color="text.secondary" > Programme - level financial performance and key metrics </Typography>
            </Box>
            <DashboardStates />
            <DashboardList />
        </Box>
    );
};